/**
 * Gender color coding and world mapping for Genus Trainer.
 *
 * Based on Dual Coding Theory: consistent color associations strengthen
 * article-noun memory. Three Worlds provide spatial/Method of Loci anchors.
 */

export const GENUS_COLORS = {
  masculine: {
    bg: 'bg-[var(--der)]/10',
    text: 'text-[var(--der-text)]',
    border: 'border-[var(--der)]',
    strong: 'bg-[var(--der)]',
    strongText: 'text-white',
    ring: 'ring-[var(--der)]',
    darkBg: 'bg-[var(--der)]',
    lightBg: 'bg-[var(--der)]/10',
    hex: '#3b82f6',  // literal: hexToRgb() in ambientColors parses this
    world: 'castle',
    worldIcon: '\u{1F3F0}',  // castle emoji
    worldLabel: 'Schloss',
  },
  feminine: {
    bg: 'bg-[var(--die)]/10',
    text: 'text-[var(--die-text)]',
    border: 'border-[var(--die)]',
    strong: 'bg-[var(--die)]',
    strongText: 'text-white',
    ring: 'ring-[var(--die)]',
    darkBg: 'bg-[var(--die)]',
    lightBg: 'bg-[var(--die)]/10',
    hex: '#f43f5e',  // literal: hexToRgb() in ambientColors parses this
    world: 'garden',
    worldIcon: '\u{1F33A}',  // hibiscus emoji
    worldLabel: 'Garten',
  },
  neuter: {
    bg: 'bg-[var(--das)]/10',
    text: 'text-[var(--das-text)]',
    border: 'border-[var(--das)]',
    strong: 'bg-[var(--das)]',
    strongText: 'text-white',
    ring: 'ring-[var(--das)]',
    darkBg: 'bg-[var(--das)]',
    lightBg: 'bg-[var(--das)]/10',
    hex: '#10b981',  // literal: hexToRgb() in ambientColors parses this
    world: 'lab',
    worldIcon: '\u{1F52C}',  // microscope emoji
    worldLabel: 'Labor',
  },
};
